import { render, staticRenderFns } from "./bimRadio.vue?vue&type=template&id=2d13356a&scoped=true&"
import script from "./bimRadio.vue?vue&type=script&lang=js&"
export * from "./bimRadio.vue?vue&type=script&lang=js&"
import style0 from "./bimRadio.vue?vue&type=style&index=0&id=2d13356a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d13356a",
  null
  
)

export default component.exports